import axios from 'axios';
import environment from 'environment';

import { JsonResponse, Pagination } from 'core/models/response';
import { Language } from '../models/language';

interface GetLanguagesResponse {
	languages: Language[];
	pagination: Pagination;
}

export const onGetAllLanguages = () => {
	return axios.get<JsonResponse<GetLanguagesResponse>>(`${environment.BASE_API_ENDPOINT}/global/languages`);
};

export const onGetLanguages = (page = 1) => {
	return axios.get<JsonResponse<GetLanguagesResponse>>(`${environment.BASE_API_ENDPOINT}/admin/languages`, {
		params: {
			page,
		},
	});
};

export const onGetLanguage = (languageId: string) => {
	return axios.get<JsonResponse<Language>>(`${environment.BASE_API_ENDPOINT}/admin/languages/${languageId}`);
};

export const onCreateLanguage = (languageData: FormData) => {
	return axios.post<JsonResponse<GetLanguagesResponse>>(`${environment.BASE_API_ENDPOINT}/admin/languages`, languageData, {
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	});
};

export const onUpdateLanguage = (languageId: string, languageData: FormData) => {
	return axios.post<JsonResponse<Language>>(`${environment.BASE_API_ENDPOINT}/admin/languages/${languageId}`, languageData, {
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	});
};

export const onDeleteLanguage = (languageId: number) => {
	return axios.delete(`${environment.BASE_API_ENDPOINT}/admin/languages/${languageId}`);
};
